import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    salesReport: ['input'],
    salesReportSuccess: ['data'],
    salesReportFailure: ['error'],

    fetchReport: ['name', 'input'],
    fetchReportSuccess: ['data'],
    fetchReportFailure: ['error'],
});


export const ReportTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    loading: false,
    error: null,
    data: [],
    dashboard: [], // TODO: use different index to avoid issues on different pages
})

const resetState = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {

    // Fetch work order actions
    [Types.SALES_REPORT]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            data: [],
        };
    },

    [Types.SALES_REPORT_SUCCESS]: (state, {data}) => {
        return {
            ...state,
            data,
            loading: false,
            error: null,
        };
    },

    [Types.SALES_REPORT_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            data: [],
        };
    },

    // Fetch work order actions
    [Types.FETCH_REPORT]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            data: [],
        };
    },

    [Types.FETCH_REPORT_SUCCESS]: (state, {data}) => {
        return {
            ...state,
            data,
            loading: false,
            error: null,
        };
    },

    [Types.FETCH_REPORT_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            data: [],
        };
    },
});



// WEBPACK FOOTER //
// ./src/Redux/ReportRedux.js